// src/components/LoadingSpinner.tsx
import React from "react";

type SpinnerProps = {
  size?: string;
  color?: string;
  className?: string;
};

const LoadingSpinner: React.FC<SpinnerProps> = ({
  size = "w-10 h-10",
  color = "border-blue-500",
  className = "",
}) => {
  return (
    <div className={`flex justify-center items-center ${className}`}>
      <div
        className={`${size} border-4 ${color} border-t-transparent rounded-full animate-spin`}
      />
    </div>
  );
};

export default LoadingSpinner;
